export const GET_BATCH_REQUEST = "GET_BATCH_REQUEST"
export const GET_BATCH_SUCCESS = "GET_BATCH_SUCCESS"
export const GET_BATCH_FAILURE = "GET_BATCH_FAILURE"

export const GET_SECTION_REQUEST = "GET_SECTION_REQUEST"
export const GET_SECTION_SUCCESS = "GET_SECTION_SUCCESS"
export const GET_SECTION_FAILURE = "GET_SECTION_FAILURE"

export const GET_TYPE_REQUEST = "GET_TYPE_REQUEST"
export const GET_TYPE_SUCCESS = "GET_TYPE_SUCCESS"
export const GET_TYPE_FAILURE = "GET_TYPE_FAILURE"

export const GET_TAG_REQUEST = "GET_TAG_REQUEST"
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS"
export const GET_TAG_FAILURE = "GET_TAG_FAILURE"

export const GET_CATEGORY_REQUEST = "GET_CATEGORY_REQUEST"
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS"
export const GET_CATEGORY_FAILURE = "GET_CATEGORY_FAILURE"

export const GET_ADMIN_REQUEST = "GET_ADMIN_REQUEST"
export const GET_ADMIN_SECCESS = "GET_ADMIN_SECCESS"
export const GET_ADMIN_FAILURE = "GET_ADMIN_FAILURE"